var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sessions"},[_c('ag-table',{attrs:{"data-source-api":_vm.getAllSessionVolunteers,"grid-options":_vm.gridOptions,"permissions":_vm.permissions,"is-entities-response":false,"rtl":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }